import { createSlice } from "@reduxjs/toolkit";
import { AuthState } from "../../state/auth/AuthState.type";
import {SS_TOKEN, LS_USER} from "../../common/constants/storages";
import * as _thunk from "./Auth.thunk";

const initialState: AuthState = {
    user: null,
    roles: [],
    client: null,
    errorMessage: '',
    loginFinished: false,
    is2FA: false,
    needPassword: false,
    doAuthMe: false,
    type: '',
    permissions: {} as Record<string, boolean>,
    pages: {} as Record<string, boolean>,
    widgets: {} as Record<string, boolean>,
    cms: {} as Record<string, boolean>
}

export const authSlice = createSlice({
    name: "authSlice",
    reducers: {
        clearLoginState: (state) => {
            state.is2FA = false
            state.needPassword = false
            state.doAuthMe = false
            state.loginFinished = false
        }
    },
    initialState,
    extraReducers: (builder) => { builder
        .addCase(_thunk.postLogin.pending, (state: AuthState, action) => {
            //state.isLoading = true;
            state.errorMessage = "";
        })
        .addCase(_thunk.postLogin.fulfilled, (state: AuthState, action) => {
            //state.isLoading = false;
            state.is2FA = action.payload.is2FA
            state.needPassword = action.payload.setPassword
            if (action.payload.token) {
                let token = action.payload.token.token
                sessionStorage.setItem(SS_TOKEN, token);
                state.doAuthMe = true
            }
        })
        .addCase(_thunk.postLogin.rejected, (state: AuthState, action) => {
            //state.isLoading = false;
            state.errorMessage = action.payload;
        })
        .addCase(_thunk.setChangePassword.fulfilled, (state: AuthState, action) => {
            if (action.payload.isFirstSet) {
                state.needPassword = action.payload.isFirstSet
            }
        })
        .addCase(_thunk.authMe.rejected, (state: AuthState, action) => {
            state.errorMessage = action.payload;
        })
        .addCase(_thunk.authMe.fulfilled, (state: AuthState, action) => {
            state.user = {
                id: action.payload.user.id,
                name: action.payload.user.name
            };
            localStorage.setItem(LS_USER, JSON.stringify(action.payload.user.id));

            state.roles = action.payload.user.roles;
            state.client = action.payload.user.client;
            state.permissions = action.payload.policy.permissions;
            state.pages = action.payload.policy.pages;
            state.widgets = action.payload.policy.widgets;
            state.cms = action.payload.policy.cms;
            state.type = action.payload.policy.type;
            state.loginFinished = true
        })
        .addCase(_thunk.postRegistration.pending, (state, action) => {
            //    state.loader = true;
        })
        .addCase(_thunk.postRegistration.fulfilled, (state, action) => {
            //state.loader = false;
            //state.is2FA = true
            //state.email = action.payload?.user.email || ''; // ? action.payload.user.email : ''
        })
        .addCase(_thunk.postRegistration.rejected, (state, action) => {
            //state.errorMessage = action.payload;
            //state.loader = false;
        })

    }
})

export const {clearLoginState} = authSlice.actions
export default authSlice.reducer;